import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { AuthComponent } from "./auth-section/auth/auth.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavbarComponent } from "./shared/navbar/navbar.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { DoctorsComponent } from "./doctor-section/doctors/doctors.component";
import { DoctorsRegisterComponent } from "./doctor-section/doctors-register/doctors-register.component";
import { PatientsComponent } from "./patient-section/patients/patients.component";
import { PatientsRegisterComponent } from "./patient-section/patients-register/patients-register.component";
import { DoctypeComponent } from "./doctype-section/doctype/doctype.component";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { HomeComponent } from "./home-section/home/home.component";
import { SinglepatientComponent } from "./patient-section/single-patient/singlepatient/singlepatient.component";
import { NgxPaginationModule } from "ngx-pagination";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { OrderModule } from "ngx-order-pipe";
import { AutoCompleteModule } from "primeng/autocomplete";
import { FilterPipeModule } from "ngx-filter-pipe";
import { CalendarModule } from "primeng/calendar";
import {MultiSelectModule} from 'primeng/multiselect';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogModule, DialogService } from "primeng/dynamicdialog";
import { DocPopupComponent } from "./doctor-section/popup-section/doc-popup/doc-popup.component";
import { TableModule } from "primeng/table";
import { SingledoctorComponent } from "./doctor-section/single-doctor/singledoctor/singledoctor.component";
import { AppointmentComponent } from "./appointment-section/appointment/appointment/appointment.component";
import { HospitalComponent } from './hospital-section/hospital/hospital.component';
import { HospitalRegisterComponent } from './hospital-section/hospital-register/hospital-register.component';
import { HospitalDoctorsComponent } from './hospital-section/hospital-doctors/hospital-doctors.component';
import { HospitaldocregComponent } from './hospital-section/hospital-doctors/hospitaldoc-register/hospitaldocreg/hospitaldocreg.component';
import { HosdocprofileComponent } from './hospital-section/hospital-doctors/hosdocProfile/hosdocprofile/hosdocprofile.component';
import { PatientAppointmentComponent } from './appointment-section/patient-appointment/patient-appointment/patient-appointment.component';
import { HospitalimagesComponent } from './hospital-section/hospital-images/hospitalimages/hospitalimages.component';
import { AdComponent } from './ad-section/ad/ad.component';
import { LabComponent } from './lab-section/lab/lab.component';
import { AddlabComponent } from './lab-section/addlab/addlab.component';
import { AdslistComponent } from './ad-section/adslist/adslist.component';
import { FeaturesComponent } from './feature-section/features/features.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    NavbarComponent,
    SidebarComponent,
    DoctorsComponent,
    DoctorsRegisterComponent,
    PatientsComponent,
    PatientsRegisterComponent,
    DoctypeComponent,
    HomeComponent,
    SinglepatientComponent,
    DocPopupComponent,
    SingledoctorComponent,
    AppointmentComponent,
    HospitalComponent,
    HospitalRegisterComponent,
    HospitalDoctorsComponent,
    HospitaldocregComponent,
    HosdocprofileComponent,
    PatientAppointmentComponent,
    HospitalimagesComponent,
    AdComponent,
    LabComponent,
    AddlabComponent,
    AdslistComponent,
    FeaturesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AppRoutingModule,
    HttpClientModule,
    Ng2SearchPipeModule,
    NgxPaginationModule,
    OrderModule,
    MultiSelectModule,
    ToastModule,
    AutoCompleteModule,
    ToastModule,
    TableModule,
    BrowserAnimationsModule,
    DynamicDialogModule,
    FilterPipeModule,
    CalendarModule,
    ConfirmDialogModule,
    BrowserAnimationsModule
  ],
  entryComponents: [DocPopupComponent],
  providers: [DialogService],
  bootstrap: [AppComponent]
})
export class AppModule {}
